/*@ngInject*/
const NavigationUtil = function (umsLog, navigationItemType, formTemplateType) {
    function inspectNavigationItems(navigationItems, parentNavigationItem, shouldProcessFn, processNavigationItemFn, shouldContinueInspectingFn) {
        var result;

        _.each(navigationItems, function (navigationItem, index) {
            if (shouldProcessFn(navigationItem, parentNavigationItem, index, result)) {
                result = processNavigationItemFn(navigationItem, parentNavigationItem, index);

                if (shouldContinueInspectingFn(navigationItem, parentNavigationItem, index, result)) {
                    if (!_.isEmpty(navigationItem.children)) {
                        result = inspectNavigationItems(navigationItem.children, navigationItem, shouldProcessFn, processNavigationItemFn, shouldContinueInspectingFn);
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        });

        return result;
    }

    function buildId(navItem, id, parentId) {
        if (parentId) {
            navItem.id = parentId + '-' + id;
        } else {
            navItem.id = id;
        }
    }

    function buildOwnerId(navItem) {
        var ownerUri = navItem.ownerUri || '',
            ownerId = ownerUri.substr(ownerUri.lastIndexOf('/') + 1, ownerUri.length);
        navItem.ownerId = parseInt(ownerId);
    }

    function localizeDisplayName(navItem, translations) {
        if (navItem.translateDisplayName) {
            navItem.displayName = _.get(translations, navItem.displayName);
            navItem.translateDisplayName = false;
        }
    }

    this.openSelectedListToSelectedItem = function (navigationList, selectedNavItemId) {
        if (selectedNavItemId) {
            var selectedHierarchyIndexList = selectedNavItemId.split('-'),
                selectedItem;

            // remove the last item as it will not open
            selectedHierarchyIndexList.pop();

            _.forEach(selectedHierarchyIndexList, function (item, index) {
                if (index === 0) {
                    selectedItem = navigationList[item];
                } else {
                    selectedItem = selectedItem.children[item];
                }

                selectedItem.isOpen = true;
            });
        }
    };

    this.getSelectedNavItem = function (rootNavigationItem, currentState, selectedNavItemType, subSelectionId, hasSubSelection, updateSelectedNavigationItem, currentlySelectedNavItem) {
        var selectedNavItem;

        if(updateSelectedNavigationItem) {
            selectedNavItem = this.getForcedServerSelectedNavItem(rootNavigationItem);
            if(selectedNavItem) {
                //Clear property to avoid this being re-selected later
                selectedNavItem.forceSelection = false;
                //Ensure it is marked selected for it is highlighted in the left nav
                selectedNavItem.selected = true;
            }
        }

        if (!selectedNavItem && updateSelectedNavigationItem) {
            selectedNavItem = this.getServerSelectedNavItem(rootNavigationItem);
        }

        if (!selectedNavItem) {
            if (updateSelectedNavigationItem) {
                if (currentlySelectedNavItem) {
                    selectedNavItem = this.getDefaultSelectedNavItem(this.getRootContextNavItem(rootNavigationItem, currentlySelectedNavItem.contextUri));

                    // If we fell back to the root navigation item, we need to reset the selected item and handle it in the logic below.
                    if (selectedNavItem === rootNavigationItem) {
                        selectedNavItem = null;
                    }
                } else {
                    // Otherwise select the default based on the root.
                    selectedNavItem = this.getDefaultSelectedNavItem(rootNavigationItem);
                }
            } else if (!currentlySelectedNavItem) {
                // We only want to get the selected nav item based on the state if there is no current
                // selected nav item
                selectedNavItem = this.getStateSelectedNavItem(rootNavigationItem.children, currentState, selectedNavItemType, subSelectionId, hasSubSelection);
            }

            if (!selectedNavItem && currentlySelectedNavItem) {
                selectedNavItem = this.getCurrentlySelectedNavItem(rootNavigationItem.children, currentlySelectedNavItem);
            }

            if (!selectedNavItem) {
                // Fall back to state-selected item if we can't find the currently selected nav item above, and log an error
                selectedNavItem = this.getStateSelectedNavItem(rootNavigationItem.children, currentState, selectedNavItemType, subSelectionId, hasSubSelection);
                if (currentlySelectedNavItem) {
                    umsLog.warn('Unable to determine the selected nav item event though there is a nav item currently selected!');
                }
            }

            //Fall back processing if selectedNavItem cannot be determined
            if(!selectedNavItem){
                selectedNavItem = this.getServerSelectedNavItem(rootNavigationItem);
                if (!selectedNavItem) {
                    selectedNavItem = this.getDefaultSelectedNavItem(rootNavigationItem);
                }
                if (!selectedNavItem) {
                    //Fallback to the submission navigation item
                    selectedNavItem = _.find(rootNavigationItem.children, function (item) {
                        return item.formTemplateType === formTemplateType.SUBMISSION;
                    });
                }
                if (!selectedNavItem) {
                    selectedNavItem = _.first(rootNavigationItem.children);
                }
                selectedNavItem.selected = true;
            }
        }

        return selectedNavItem;
    };

    this.getForcedServerSelectedNavItem = function (navigationItem) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return !result;
        }

        function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
            let selectedNavItem = null;

            if (navigationItem.forceSelection) {
                selectedNavItem = navigationItem;
            }

            return selectedNavItem;
        }

        return inspectNavigationItems([navigationItem], null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    };

    this.getServerSelectedNavItem = function (navigationItem) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return !result;
        }

        function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
            var selectedNavItem = null;

            if (navigationItem.selected) {
                selectedNavItem = navigationItem;
            }

            return selectedNavItem;
        }

        return inspectNavigationItems([navigationItem], null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    };

    this.getDefaultSelectedNavItem = function (navigationItem) {
        var selectedNavigationItem = navigationItem,
            hasChildren = !_.isNil(navigationItem) && !_.isEmpty(navigationItem.children),
            defaultChildIndex = !_.isNil(navigationItem) ? navigationItem.defaultChildIndex : null;

        if(_.isNil(navigationItem)){
            return null;
        }

        if (hasChildren) {
            if (defaultChildIndex >= 0) {
                selectedNavigationItem = navigationItem.children[defaultChildIndex];
                return this.getDefaultSelectedNavItem(selectedNavigationItem);
            } else if (navigationItem.type === navigationItemType.NONE) {
                selectedNavigationItem = navigationItem.children[0];
                return this.getDefaultSelectedNavItem(selectedNavigationItem);
            }
        }

        selectedNavigationItem.selected = true;
        return selectedNavigationItem;
    };

    this.getRootContextNavItem = function (navigationItem, contextUri) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return !result;
        }

        function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
            var rootContextNavItem = null;

            if (navigationItem.contextUri === contextUri) {
                rootContextNavItem = navigationItem;
            }

            return rootContextNavItem;
        }

        return inspectNavigationItems([navigationItem], null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    };

    this.getStateSelectedNavItem = function (navigationList, currentState, selectedNavItemType, subSelectionId, hasSubSelection) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return !result;
        }

        function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
            var isSelectedNavType = _.isEqual(navigationItem.type, selectedNavItemType),
                isSelectedNavSubType = _.isEqual(navigationItem.ownerId, subSelectionId),
                selectedNavItem = null;

            if (isSelectedNavType) {
                if (hasSubSelection) {
                    if (isSelectedNavSubType) {
                        selectedNavItem = navigationItem;
                        selectedNavItem.selected = true;
                    }
                } else {
                    selectedNavItem = navigationItem;
                    selectedNavItem.selected = true;
                }
            }

            return selectedNavItem;
        }

        return inspectNavigationItems(navigationList, null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    };



    this.getCurrentlySelectedNavItem = function (navigationList, currentlySelectedNavItem) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return !result;
        }

        const processNavigationItemFn = (navigationItem, parentNavigationItem, index) => {
            let selectedNavItem = null;

            if (this.areNavigationItemsEqual(navigationItem, currentlySelectedNavItem)) {
                selectedNavItem = navigationItem;
                selectedNavItem.selected = true;
            }

            return selectedNavItem;
        };

        if (currentlySelectedNavItem) {
            return inspectNavigationItems(navigationList, null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
        }

        return null;
    };

    this.areNavigationItemsEqual = function (navigationItem, navigationItem2)
    {
        return _.isNil(navigationItem) && _.isNil(navigationItem2)
            || (!_.isNil(navigationItem)
                && !_.isNil(navigationItem2)
                && _.isEqual(navigationItem.type, navigationItem2.type)
                && _.isEqual(navigationItem.ownerId, navigationItem2.ownerId)
                && _.isEqual(navigationItem.contextUri, navigationItem2.contextUri));
    }

    this.isForceSelectionInNavigationTree = function (navigationItem)
    {
        let result = false;
        if(navigationItem.forceSelection){
            return true;
        }
        else{
            _.each(navigationItem.children, (navigationItem) => {
                if (this.isForceSelectionInNavigationTree(navigationItem)) {
                    result = true;
                    return false;
                }
            });
        }
        return result;
    }

    this.generateIdForHierarchyLevel = function (hierarchyLevel, translations, parentNavigationItem) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return true;
        }

        function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
            buildId(navigationItem, index.toString(), parentNavigationItem ? parentNavigationItem.id : null);
            buildOwnerId(navigationItem);
            localizeDisplayName(navigationItem, translations);
        };

        return inspectNavigationItems(hierarchyLevel, parentNavigationItem, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    };

    this.findOwnerUri = function (navigationList, ownerUri) {
        function shouldProcessFn(navigationItem, parentNavigationItem, index, result) {
            return !result;
        }

        function processNavigationItemFn(navigationItem, parentNavigationItem, index) {
            if (navigationItem.ownerUri === ownerUri) {
                return navigationItem;
            }

            return null;
        }

        return inspectNavigationItems(navigationList, null, shouldProcessFn, processNavigationItemFn, shouldProcessFn);
    };
};

angular.module('gw-um-submission')
    .service('navigationUtil', NavigationUtil);
